<template>
  <div>
    <div class="style1 content-style">
      <div style="padding:20px 10px">
        <mu-container>
          <div>
            <span class="tab_order" :class="orderActive == null ? 'order-active' : ''" @click="getdate()">全部</span>
            <span class="tab_order" :class="orderActive == 0 ? 'order-active' : ''" @click="tabOrder(0)">待支付</span>
            <span class="tab_order" :class="orderActive == 1 ? 'order-active' : ''" @click="tabOrder(1)">待充值</span>
            <span class="tab_order" :class="orderActive == 3 ? 'order-active' : ''" @click="tabOrder(3)">已完成</span>
            <span class="tab_order" :class="orderActive == -1 ? 'order-active' : ''" @click="tabOrder(-1)">已关闭</span>
          </div>
          <div v-for="item in orderList" :key="item.id">
            <div></div>
          </div>
          <mu-flex justify-content="end">
            <mu-pagination :total="orderTotal" :current.sync="orderCurrent" @change="orderChange"></mu-pagination>
          </mu-flex>
        </mu-container>
      </div>
    </div>
  </div>
</template>


<script>
  export default {
    name: 'accountdetails',

    props: ['orderList'],
    data() {
      return {}
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/AccountDetails/AccountDetails.vue